import React from "react";
import classNames from "classnames/bind";
import styles from "./Service.module.scss";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";

const cx = classNames.bind(styles);

export default function Service({ id, data }) {
  return (
    <div id={id} className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("section-title-box")}>
          <p
            {...useScrollFadeIn("up", 1, 0.1)}
            className={`${cx("section-title")} font-play-700 `}
          >
            service
          </p>
          <div {...useScrollFadeIn("up", 1, 0.2)} className={cx("title-box")}>
            <p className={cx("title")}>
              {data?.section2?.title}
              <b className={cx("title-b")}>.</b>
            </p>
          </div>
          <p {...useScrollFadeIn("up", 1, 0.3)} className={cx("text")}>
            {data?.section2?.description}
          </p>
        </div>
        <div className={cx("content-top-inner")}>
          <div {...useScrollFadeIn("up", 1, 0.3)} className={cx("content-box")}>
            <div className={cx("content-title-box")}>
              <p className={`${cx("content-sub-title")} font-play-700`}>
                {data?.section2?.section2_1?.subTitle}
              </p>
              <p className={cx("content-title")}>
                {data?.section2?.section2_1?.title}
              </p>
              <p className={cx("content-text")}>
                {data?.section2?.section2_1?.description}
              </p>
            </div>
            <img
              className={cx("content-img")}
              src={data?.section2?.section2_1?.imageUrl}
              alt={data?.section2?.section2_1?.imageUrl}
            />
          </div>
          <div {...useScrollFadeIn("up", 1, 0.4)} className={cx("content-box")}>
            <div className={cx("content-title-box")}>
              <p className={`${cx("content-sub-title")} font-play-700`}>
                {data?.section2?.section2_2?.subTitle}
              </p>
              <p className={cx("content-title")}>
                {data?.section2?.section2_2?.title}
              </p>
              <p className={cx("content-text")}>
                {data?.section2?.section2_2?.description}
              </p>
            </div>
            <img
              className={cx("content-img")}
              src={data?.section2?.section2_2?.imageUrl}
              alt={data?.section2?.section2_2?.imageUrl}
            />
          </div>
        </div>
        <div
          {...useScrollFadeIn("up", 1, 0.2)}
          className={cx("content-bottom-inner")}
        >
          <div className={cx("content-bottom-left-box")}>
            <div className={cx("content-bottom-title-box")}>
              <p className={`${cx("content-sub-title")} font-play-700`}>
                {data?.section2?.section2_3?.subTitle}
              </p>
              <p className={cx("content-title")}>
                {data?.section2?.section2_3?.title}
              </p>
              <p className={cx("content-text")}>
                {data?.section2?.section2_3?.description}
              </p>
            </div>
            <div className={cx("content-delivery-box")}>
              <div className={cx("content-delivery-title-inner")}>
                <div className={cx("content-delivery-title-box")}>
                  <p className={cx("content-delivery-title")}>평균 제작 기간</p>
                  <p className={cx("content-delivery-text")}>3일</p>
                </div>
                <div className={cx("content-delivery-title-box")}>
                  <p className={cx("content-delivery-title")}>평균 배송 기간</p>
                  <p className={cx("content-delivery-text")}>2일</p>
                </div>
              </div>
              <div className={cx("progress-box")}>
                <div className={cx("progress-bar")}>
                  <div className={cx("produce-progress-bar")} />
                  <div className={cx("delivery-progress-bar")} />
                </div>
              </div>
            </div>
          </div>
          <div className={cx("content-bottom-box")}>
            <img
              className={cx("content-bottom-img")}
              src={data?.section2?.section2_3?.imageUrl}
              alt={data?.section2?.section2_3?.imageUrl}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
